/**
 * Central data for service detail pages.
 * Add new entries here to get new routes at /services/:slug
 * Slug is used in URL (e.g. virtual-table → /services/virtual-table).
 */
export const services = [
  {
    slug: 'virtual-table',
    title: 'Virtuelne Table',
    description: 'Virtuelne table (digitalne instrument table) zamjenjuju klasične analogne i pružaju potpuno digitalni prikaz brzine, obrtaja, navigacije i upozorenja. Nudimo aktivaciju fabričkih virtuelnih tabla, nadogradnju na digitalne kokpite te konfiguraciju i personalizaciju prikaza prema vašim željama. Usluga uključuje podršku za head-up display (HUD), različite teme prikaza i integraciju sa navigacijom i asistencijama u vožnji. Kompatibilno s većinom modernih modela (VW grupa, BMW, Mercedes, Audi).',
    images: ['/virtual.jpg', '/virtual3.jpeg', '/virtual2.jpg'].filter(Boolean),
  },
  {
    slug: 'multimedia',
    title: 'Multimedija',
    description: 'Aktivacija CarPlay i Android Auto, podešavanje fabričkih infotainment sistema, ugradnja i nadogradnja multimedijskih jedinica te personalizacija audio i video sadržaja. Nudimo ažuriranje softvera, otključavanje skrivenih funkcija i integraciju pametnih uređaja s vozilom. Kompatibilno s VW grupom, BMW, Mercedes, Audi i drugim markama.',
    images: ['/multimedia.jpg', '/multimedia2.jpg', '/multimedia3.jpg', '/multimedia4.jpg', '/multimedia5.jpg'].filter(Boolean),
  },
  {
    slug: 'osvjetljenje',
    title: 'Osvjetljenje',
    description: 'Ambijentalno osvjetljenje enterijera, aktivacija i konfiguracija dinamičkih svjetala, LED nadogradnje te personalizacija boja i intenziteta. Uključuje podešavanje dnevnih i pozicijskih svjetala, nadogradnju na matrix/LED tehnologiju i integraciju s komfor i vizualnim postavkama vozila.',
    images: [
      { type: 'video', src: '/lighting.mp4' },
      '/lighting.jpg'
    ].filter(Boolean),

  },
  {
    slug: 'retrofit',
    title: 'Retrofiti i ugradnje',
    description: 'Profesionalne retrofit ugradnje OEM opreme: multimedije, virtuelne table, ambijentalno osvjetljenje, kamere i senzori, sportski upravljači i dodatna oprema. Sve ugradnje u fabričkom izgledu s punom CAN-BUS integracijom i bez grešaka u sustavu.',
    images: ['/retrofit.jpeg', '/retrofit2.jpeg', '/retrofit3.jpg', '/retrofit4.jpeg'].filter(Boolean),
  },
  {
    slug: 'konverzija-sistema',
    title: 'Konverzija sistema',
    description: 'Konverzija vozila iz drugih tržišta (npr. USA, Azija) na europske standarde: mijenjanje jedinica (milje/km), radio frekvencije, jezika sustava, navigacijskih mapa i svih postavki prema vašem tržištu. Nudimo i prilagodbu opreme i softvera za pravnu i tehničku usklađenost.',
    images: ['/system.jpeg', '/system2.jpeg'].filter(Boolean),
  },
];

const bySlug = services.reduce((acc, s) => ({ ...acc, [s.slug]: s }), {});

export const getServiceBySlug = (slug) => (slug ? bySlug[slug] : null);
